///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, OnInit, AfterViewInit, OnDestroy, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators/map';

import { TranslationsProvider } from '../../../core/translations.provider';
import { ModelDataResult } from '../../../core/data/model-data-result';
import { AuthorizationService } from '../../../core/auth/authorization.service';
import { DataService } from '../../../core/data/data.service';
import { DataServiceFactory } from '../../../core/data/data-service-factory';

import { State } from '@progress/kendo-data-query';

import { ProgressServiceFactory } from '../../../core/data/progress-service-factory';
import { DpTransparentKorisnik } from '../../../data/dp-transparent/korisnik.model';
import { getKorisnikConfig } from '../../../data/dp-transparent/korisnik.config';

import { NotificationService } from './../../../core/notification/notification.service';
import { Notification } from './../../../core/notification/notification';

@Component({
    selector: 'kb-app-layout',
    templateUrl: './app-layout.view.component.html',
    styleUrls: ['./app-layout.view.component.css'],
})
export class AppLayoutViewBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    public $authorizationService: AuthorizationService;
    public $progressServiceFactory: ProgressServiceFactory;
    public $dataServices: { [key: string]: DataService<any> };
    public $dataServicesData: { [key: string]: Observable<any> };
    public $dataServicesResult: { [key: string]: BehaviorSubject<ModelDataResult<any>> };
    public $notificationService: NotificationService;

    public $dataServicesState: { [key: string]: State } = {
        dsKorisnik: {
            skip: 0,
            take: 20,
        },
    };

    public $dataModels: any = {
        dsKorisnikModel: {},
    };
    public $config: any = {
        components: {
            customhtml0: {},

            languagesDdl: {
                data: this.getLanguages(),
                textField: 'label',
                valueField: 'key',
            },
            userdropdown0: {},
            navigationpanelbar0: {},
        },
    };

    public $navigationData = [
        {
            title: 'Transparentnost',
            titleKey: 'modules.Transparentnost.label',
            thumbnail: {
                background: '#1c4284',
                color: '#eef4ff',
                icon: 'fa-bank',
            },
            children: [
                {
                    title: 'Racuni',
                    titleKey: 'modules.Transparentnost.views.Racuni.label',
                    label: 'Računi',
                    routerLink: '/',
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    title: 'Isplate',
                    titleKey: 'modules.Transparentnost.views.Isplate.label',
                    label: 'Isplate',
                    routerLink: '/transparentnost/isplate',
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
    ];

    constructor(public injector: Injector) {
        this.$authorizationService = this.injector.get(AuthorizationService);
        this.$progressServiceFactory = this.injector.get(ProgressServiceFactory);
        this.$notificationService = this.injector.get(NotificationService);

        const dsConfig = this.getDataServicesConfig();
        this.$dataServices = {
            dsKorisnik: this.$progressServiceFactory.getService<DpTransparentKorisnik>(
                dsConfig['dsKorisnik'],
                this.$dataServicesState['dsKorisnik']
            ),
        };

        this.$dataServicesData = {
            dsKorisnik: this.getDataChanges('dsKorisnik'),
        };

        this.$dataServicesResult = {
            dsKorisnik: this.getDataResult('dsKorisnik'),
        };
        this.filterNavigationData();

        const translationsProvider = this.injector.get(TranslationsProvider);
        translationsProvider.useDefaultLanguage();
    }

    public ngOnInit(): void {
        this['onInit']();

        for (const dataSourceName of Object.keys(this.$dataServices)) {
            this.read(dataSourceName);
            this.dataServiceErrors(dataSourceName);
        }
    }

    public ngAfterViewInit(): void {
        this['onShow']();
    }

    public ngOnDestroy(): void {
        this['onHide']();
    }

    public getLanguages(): any[] {
        return [
            {
                label: 'English',
                culture: 'en-US',
                order: 0,
                key: 'translations.default',
            },
        ];
    }

    private filterNavigationData(): void {
        this.$navigationData.forEach(module => {
            const views = module.children.filter(view => this.$authorizationService.isAuthorized(view.authorization));
            module.children = views;
        });

        this.$navigationData = this.$navigationData.filter(module => module.children.length);
    }

    public read(dataSourceName): void {
        this.$dataServices[dataSourceName].read();
    }

    public getDataChanges(dataSourceName): Observable<any[]> {
        const dataService = this.$dataServices[dataSourceName];
        return dataService.dataChanges().pipe(map(response => (response ? response.data : [])));
    }

    public getDataResult(dataSourceName): BehaviorSubject<ModelDataResult<any>> {
        return this.$dataServices[dataSourceName].dataChanges();
    }

    public dataServiceErrors(dataSourceName): void {
        this.$dataServices[dataSourceName].errors.subscribe((err: any) => {
            if (err) {
                const message = (err.error && err.error.message) || err.message;
                this.$notificationService.notify(new Notification(`<ul><li>${message}<li></ul>`, 'error', 10000));
            }
        });
    }

    protected getDataServicesConfig() {
        const config = {
            dsKorisnik: getKorisnikConfig(),
        };

        return config;
    }
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/application/app-layout/app-layout.view.base.component.ts